
/**
 * GHŌUD — Selezione obbligatoria della taglia
 * Script separato dal theme.js
 */

(function () {
  'use strict';

  var productSectionSelector = '[data-section-type="product"]';
  var sizePickerSelector = '[data-ghoud-size-picker]';

  var messages = {
    it: 'Seleziona una taglia',
    en: 'Please select a size',
    fr: 'Veuillez sélectionner une pointure',
    de: 'Bitte wähle eine Größe'
  };

  function getActiveSizePicker(section) {
    var pickers = Array.prototype.slice.call(
      section.querySelectorAll(sizePickerSelector)
    );

    if (!pickers.length) return null;

    return pickers.find(function (picker) {
      return picker.getClientRects().length > 0;
    }) || pickers[0];
  }

  function hasSelectedSize(picker) {
    var checkedRadio = picker.querySelector(
      'input[type="radio"][data-single-option-selector]:checked:not(:disabled)'
    );

    if (checkedRadio && checkedRadio.value.trim() !== '') {
      return true;
    }

    var sizeSelect = picker.querySelector(
      'select[data-single-option-selector]'
    );

    return !!(
      sizeSelect &&
      !sizeSelect.disabled &&
      sizeSelect.value.trim() !== ''
    );
  }

  function removeError(picker) {
    var error = picker.parentElement &&
      picker.parentElement.querySelector(
        '.ghoud-size-error[data-ghoud-error-for="size"]'
      );

    if (error) error.remove();
  }

  function showError(picker) {
    var error = picker.parentElement &&
      picker.parentElement.querySelector(
        '.ghoud-size-error[data-ghoud-error-for="size"]'
      );

    if (!error) {
      error = document.createElement('p');

      error.className = 'ghoud-size-error';

      error.setAttribute(
        'data-ghoud-error-for',
        'size'
      );

      error.setAttribute('role', 'alert');

      error.style.cssText =
        'color:#c62828;' +
        'font-size:12px; !important' +
        'line-height:1.8;';

      picker.insertAdjacentElement('afterend', error);
    }

    var lang = (
      document.documentElement.lang || 'en'
    ).toLowerCase().split('-')[0];

    error.textContent = messages[lang] || messages.en;
  }

  // Intercetta il submit prima del tema.
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('form[data-product-form]')
    ) {
      return;
    }

    var section = form.closest(productSectionSelector);

    if (!section) return;

    var picker = getActiveSizePicker(section);

    // Non bloccare i prodotti senza taglia.
    if (!picker) return;

    if (!hasSelectedSize(picker)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      showError(picker);
    } else {
      removeError(picker);
    }
  }, true);

  // Rimuove l'errore quando viene scelta una taglia.
  document.addEventListener('change', function (event) {
    var target = event.target;

    if (
      !(target instanceof Element) ||
      !target.matches('[data-single-option-selector]')
    ) {
      return;
    }

    var picker = target.closest(sizePickerSelector);

    if (picker && hasSelectedSize(picker)) {
      removeError(picker);
    }
  }, true);

})();
